<template>
  <div v-if="show" class="lead-stop">
    <div class="lead-stop__title">{{ $t("stopReason.title") }}</div>

    <div v-if="loading" class="lead-stop__hint">{{ $t("common.loading") }}</div>

    <template v-else>
      <div v-if="!stop" class="lead-stop__hint">
        {{ $t("stopReason.empty") }}
      </div>

      <template v-else>
        <div class="lead-stop__summary">{{ stop.summary }}</div>

        <ul v-if="stop.items.length" class="lead-stop__items">
          <li v-for="(item, index) in stop.items" :key="index">
            <span v-if="item.integration_id" class="lead-stop__int">
              {{ $t("stopReason.integration", { id: item.integration_id }) }}
            </span>
            <span v-else class="lead-stop__int">{{ $t("stopReason.selection") }}</span>
            — {{ item.text }}
          </li>
        </ul>

        <div class="lead-stop__hint">
          {{ $t("stopReason.lastCheck", { date: formatDate(stop.checked_at) }) }}
        </div>
      </template>

      <div v-if="retry" class="lead-stop__retry">
        {{
          $t("stopReason.retry", {
            attempts: retry.attempts,
            date: formatDate(retry.next_try_at),
          })
        }}
      </div>
      <div v-else-if="stop && stop.is_duplicated && !retryEnabled" class="lead-stop__hint">
        {{ $t("stopReason.retryDisabled") }}
      </div>
    </template>
  </div>
</template>

<script>
import leadApi from "~/api/lead";

// Причина, по которой лид не ушёл ни в одну интеграцию.
// Раньше она была только в логе импорта, и из-за этого дубли перезаливали руками вслепую.
export default {
  name: "LeadStopReason",
  props: {
    leadId: { type: [Number, String], default: null },
    // показываем только там, где отказ вообще возможен
    statusTechName: { type: String, default: "" },
  },
  data() {
    return { loading: false, stop: null, retry: null, retryEnabled: false };
  },
  computed: {
    show() {
      return ["no_integration_available", "duplicate", "error_duplicate", "error"].includes(
        this.statusTechName,
      );
    },
  },
  watch: {
    leadId: {
      immediate: true,
      handler(id) {
        if (id && this.show) this.load(id);
      },
    },
  },
  methods: {
    formatDate(value) {
      if (!value) return "—";
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
    },
    load(id) {
      this.loading = true;
      this.stop = null;
      this.retry = null;

      leadApi
        .getLeadStopReason(id)
        .then((res) => {
          const data = (res && res.data) || {};
          this.stop = data.stop || null;
          this.retry = data.retry || null;
          this.retryEnabled = !!data.retry_enabled;
        })
        .catch(() => {
          this.stop = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.lead-stop {
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid $mainDisabled;
  border-radius: 7px;

  &__title {
    margin-bottom: 6px;
    font-weight: 600;
  }

  &__summary {
    margin-bottom: 6px;
  }

  &__items {
    margin: 0 0 6px;
    padding-left: 18px;
    font-size: 13px;

    li {
      margin-bottom: 2px;
    }
  }

  &__int {
    font-weight: 600;
  }

  &__hint {
    font-size: 13px;
    color: $mainSecondTextColor;
  }

  &__retry {
    margin-top: 6px;
    font-size: 13px;
    color: #2d8a4e;
  }
}
</style>
